import React from "react";
import AlbumList from "../components/albumList/AlbumList";
import Player from "../components/player/Player";
import TopMenu from "../components/topMenu/TopMenu";
import RandomQueueDisplayer from "../components/randomQueueDisplayer/RandomQueueDisplayer.jsx";
import { useSavedAlbums } from "../hooks/savedAlbums/useSavedAlbums";
import ClearQueuePopup from "../components/popups/ClearQueuePopup.jsx";
import { useSelector } from "react-redux";
import { isShowingQueueDisplayer } from "../reducers/randomMode.jsx";
import { useViewport } from "../hooks/others/useViewport.jsx";
import { useManageRandomMode } from "../hooks/randomMode/useManageRandomMode.jsx";
import { SAVED_ALBUMS_PAGE_DIVISION_BREAKPOINTS } from "../utils/constants/viewConstants.jsx";
import SettingsWindow from "../components/popups/SettingsWindow/index.jsx";
import { useManageWorkers } from "../hooks/workers/useManageWorkers.jsx";
import { useUserProfile } from "../hooks/userProfile/useUserProfile.jsx";

const AlbumListContainer = React.memo(({show}) => {
    if(!show)
    {
        return;
    }

    return (
        <div className="flex-3">
            <AlbumList />            
        </div>
    )
});

const RandomQueueDisplayerContainer = React.memo(({show}) => {
    if(!show)
    {
        return;
    }

    return (
        <div className="flex-1">
            <RandomQueueDisplayer />  
        </div>
    )
});

const SavedAlbumsPage = () => {
    const showingQueueDisplayer = useSelector(isShowingQueueDisplayer);

    const alwaysShowAlbumList = useViewport({
        xs: false,
        sm: true
    }, SAVED_ALBUMS_PAGE_DIVISION_BREAKPOINTS);

    useSavedAlbums();
    useUserProfile();
    useManageWorkers();
    useManageRandomMode();

    return (
        <>
            <SettingsWindow />
            <ClearQueuePopup />
            <div className="d-flex flex-column full-height">
                <TopMenu />
                <div className="p-0_5 d-flex flex-row jc-center gap-1 flex-1 overflow-y-auto overflow-x-hidden">
                    <AlbumListContainer show={alwaysShowAlbumList || !showingQueueDisplayer} />
                    <RandomQueueDisplayerContainer show={showingQueueDisplayer} />
                </div>
                <Player />
            </div>   
        </>
    )
}

export default SavedAlbumsPage;